import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CubeDefinitionDetails } from 'types/api/SystemTenant/AROCube/CubeBuilderTypes';

export function CubeCurrentStructure({
  cube,
  subjectName,
  titleId,
}: {
  cube: CubeDefinitionDetails;
  subjectName?: string;
  titleId: string;
}) {
  const fields = [
    { label: 'Subject', value: cube.subject?.displayName || subjectName },
    { label: 'Main Dimension (KTree)', value: cube.member?.label },
    ...(cube.subjectX ? [{ label: 'Second Dimension (KTree)', value: cube.subjectX.label }] : []),
    { label: 'Time Period Set', value: cube.timePeriodSet?.label },
    { label: 'Layer Set', value: cube.layerSet?.label },
  ];

  return (
    <Stack
      component='section'
      spacing={1.25}
      aria-labelledby={titleId}
      sx={{ p: 2, bgcolor: 'background.paper', border: '1px solid #E3EBF6', borderRadius: 1 }}
    >
      <Typography id={titleId} component='h3' variant='body2' fontWeight='bold'>
        Current structure
      </Typography>
      <Stack component='dl' spacing={1} sx={{ m: 0 }}>
        {fields.map((field) => (
          <Stack key={field.label} direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.25, sm: 2 }}>
            <Typography component='dt' variant='body2' color='text.secondary' sx={{ flex: 1 }}>
              {field.label}
            </Typography>
            <Typography component='dd' variant='body2' sx={{ m: 0, flex: 1, overflowWrap: 'anywhere' }}>
              {field.value || 'Not configured'}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
